export default "__VITE_ASSET__BI6JLXaI__"